<script setup>
import { useI18n } from 'vue-i18n';
import LaisErrorState from 'dashboard/components-next/LaisErrorState.vue';

defineEmits(['back']);
const { t } = useI18n();
</script>

<template>
  <LaisErrorState
    class="mx-auto w-full max-w-[1500px] px-4 py-8 sm:px-6 lg:px-10"
    status="403"
    icon="i-lucide-lock"
    :title="t('SALES.FORBIDDEN.TITLE')"
    :description="t('SALES.FORBIDDEN.DESCRIPTION')"
    :action-label="t('SALES.FORBIDDEN.BACK')"
    action-icon="i-lucide-arrow-left"
    @action="$emit('back')"
  />
</template>
